<legend *ngIf="label"
        [class.required]="required">
        {{label | translate}}
</legend>
<div class="input-component"
     [formGroup]="formGroup"
     #inputZone
     *ngIf="controlStatus | async as status"
     [class.pristine]="!status.dirty"
     [class.valid]="!status.invalid"
     [class.invalid]="status.invalid"
     [class.required]="required">
    <div class="input-wrapper" (click)="onClickWrapper()">
        <div class="input-combobox">
            <input type="text"
                   class="input-field"
                   [formControlName]="ctrlName"
                   value="{{displayValue}}" />
            <!-- <ng-select class="aa-ng-select input-field"
                       [ngClass]="{'invalid': (invalidStatus$ | async)}"
                       [id]="fieldId"
                       [items]="items | async"
                       bindLabel="label"
                       bindValue="value"
                       [clearable]="true"
                       [searchable]="true"
                       (change)="onSelected()"
                       [addTag]="true"
                       addTagText="Validez la saisie"
                       formControlName="formControlName">
            </ng-select> -->
        </div>
        <span class="input-clear"
            *ngIf="isClearButtonShown()"
            [title]="'BUTTON.CLEAR' | translate"
            (click)="onClearClick($event)">
            <i class="fal fa-times fa-sm"
               aria-hidden="true"></i>
        </span>
        <aa-arrow-combo (arrowClick)="onArrowClick($event)">
        </aa-arrow-combo>
        <aa-check-mark9 [status]="status">
        </aa-check-mark9>
    </div>
    <aa-field-msg-error [status]="status">
    </aa-field-msg-error>
</div>
